export interface NavigationItem {
  label: string;
  icon?: string;
  route?: string;
  children?: NavigationItem[];
  disabled?: boolean;
}

export interface NavigationGroup {
  label: string;
  items: NavigationItem[];
}

export const appNavigationConfig: NavigationGroup[] = [
  {
    label: 'Database Console',
    items: [
      {
        label: 'Namespace OPD',
        icon: 'pi pi-server',
        route: '/namespaces',
      },
    ],
  },
];
